(function () {
  function init(root) {
    if (!root || root.dataset.ogcCorporateGiftingReady === 'true') return;
    root.dataset.ogcCorporateGiftingReady = 'true';

    /* Hero entrance sequence */
    var heroRevealEls = root.querySelectorAll('.hero [data-hero-reveal]');

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        heroRevealEls.forEach(function (el) {
          el.classList.add('is-visible');
        });
      });
    });

    /* Reveal animations */
    var revealEls = root.querySelectorAll('[data-reveal]');

    if (!('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
    } else {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -40px 0px'
        }
      );

      revealEls.forEach(function (el) {
        observer.observe(el);
      });
    }

    /* Occasions carousel */
    var carousel = root.querySelector('.testimonial-carousel');

    if (carousel) {
      var track = carousel.querySelector('.testimonial-scroll');
      var prev = carousel.querySelector('.tcard-nav.prev');
      var next = carousel.querySelector('.tcard-nav.next');

      if (track && prev && next) {
        function scrollAmount() {
          var card = track.firstElementChild;
          return card ? card.offsetWidth + 20 : track.clientWidth * 0.8;
        }

        function updateButtons() {
          var maxScroll = track.scrollWidth - track.clientWidth - 1;
          prev.disabled = track.scrollLeft <= 0;
          next.disabled = track.scrollLeft >= maxScroll;
        }

        prev.addEventListener('click', function () {
          track.scrollBy({
            left: -scrollAmount(),
            behavior: 'smooth'
          });
        });

        next.addEventListener('click', function () {
          track.scrollBy({
            left: scrollAmount(),
            behavior: 'smooth'
          });
        });

        track.addEventListener('scroll', updateButtons, {
          passive: true
        });

        window.addEventListener('resize', updateButtons);
        updateButtons();
      }
    }

    /* Mobile gallery lightbox */
    var lightbox = root.querySelector('[data-gallery-lightbox]');

    if (lightbox) {
      var lightboxImage = lightbox.querySelector('.gallery-lightbox-image');
      var lightboxCaption = lightbox.querySelector('.gallery-lightbox-caption');
      var closeButton = lightbox.querySelector('.gallery-lightbox-close');
      var previousButton = lightbox.querySelector('.gallery-lightbox-prev');
      var nextButton = lightbox.querySelector('.gallery-lightbox-next');
      var galleryImages = Array.prototype.slice.call(
        root.querySelectorAll('.gift-section .gallery .tile img')
      );

      var activeIndex = 0;
      var touchStartX = 0;
      var touchEndX = 0;

      function isMobileGallery() {
        return window.matchMedia('(max-width: 820px)').matches;
      }

      function getCaption(image) {
        var tile = image.closest('.tile');
        var caption = tile ? tile.querySelector('figcaption') : null;

        return caption
          ? caption.textContent.replace(/\s+/g, ' ').trim()
          : image.alt;
      }

      function showImage(index) {
        if (!galleryImages.length) return;

        if (index < 0) {
          index = galleryImages.length - 1;
        }

        if (index >= galleryImages.length) {
          index = 0;
        }

        activeIndex = index;

        var image = galleryImages[activeIndex];

        lightboxImage.src = image.currentSrc || image.src;
        lightboxImage.alt = image.alt || '';
        lightboxCaption.textContent = getCaption(image);
      }

      function openLightbox(index) {
        if (!isMobileGallery()) return;

        showImage(index);
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';

        window.requestAnimationFrame(function () {
          closeButton.focus();
        });
      }

      function closeLightbox() {
        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }

      function showPrevious() {
        showImage(activeIndex - 1);
      }

      function showNext() {
        showImage(activeIndex + 1);
      }

      galleryImages.forEach(function (image, index) {
        var tile = image.closest('.tile');

        if (tile) {
          tile.setAttribute('tabindex', '0');
          tile.setAttribute('role', 'button');
          tile.setAttribute('aria-label', 'Open image: ' + (image.alt || 'gallery image'));

          tile.addEventListener('click', function (event) {
            if (!isMobileGallery()) return;

            /*
             * Preserve links inside figcaptions.
             * Tapping a linked caption still opens its product page.
             */
            if (event.target.closest('a')) return;

            openLightbox(index);
          });

          tile.addEventListener('keydown', function (event) {
            if (!isMobileGallery()) return;

            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              openLightbox(index);
            }
          });
        }
      });

      closeButton.addEventListener('click', closeLightbox);
      previousButton.addEventListener('click', showPrevious);
      nextButton.addEventListener('click', showNext);

      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) {
          closeLightbox();
        }
      });

      lightbox.addEventListener(
        'touchstart',
        function (event) {
          touchStartX = event.changedTouches[0].screenX;
        },
        { passive: true }
      );

      lightbox.addEventListener(
        'touchend',
        function (event) {
          touchEndX = event.changedTouches[0].screenX;

          var distance = touchEndX - touchStartX;

          if (Math.abs(distance) < 50) return;

          if (distance > 0) {
            showPrevious();
          } else {
            showNext();
          }
        },
        { passive: true }
      );

      document.addEventListener('keydown', function (event) {
        if (!lightbox.classList.contains('is-open')) return;

        if (event.key === 'Escape') {
          closeLightbox();
        }

        if (event.key === 'ArrowLeft') {
          showPrevious();
        }

        if (event.key === 'ArrowRight') {
          showNext();
        }
      });

      window.addEventListener('resize', function () {
        if (!isMobileGallery() && lightbox.classList.contains('is-open')) {
          closeLightbox();
        }
      });
    }

    if (window.lucide) {
      window.lucide.createIcons({
        attrs: {
          'aria-hidden': 'true'
        }
      });
    }
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-ogc-corporate-gifting]')
      .forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();